var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucessUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_9159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97398 11.5004H2.02597C1.68045 11.5024 1.34022 11.4155 1.03796 11.2481C0.735696 11.0807 0.481565 10.8384 0.299975 10.5444C0.12063 10.2575 0.0180652 9.92927 0.00212932 9.59129C-0.0138065 9.25331 0.0574221 8.91691 0.208975 8.61439L4.18998 1.60639C4.36129 1.27228 4.62174 0.992106 4.94248 0.796905C5.26323 0.601705 5.63174 0.499094 6.00721 0.50044C6.38268 0.501786 6.75045 0.607036 7.06979 0.804531C7.38912 1.00203 7.64756 1.28406 7.81648 1.61939L11.7775 8.58989C11.9345 8.89464 12.0098 9.23488 11.9962 9.57743C11.9825 9.91997 11.8803 10.2531 11.6995 10.5444C11.5179 10.8383 11.2639 11.0806 10.9617 11.248C10.6595 11.4154 10.3194 11.5023 9.97398 11.5004Z",
    fill: "#12B669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_9159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessUp);
export default __webpack_public_path__ + "static/media/sucessUp.1eebfaa19db39c8009da317de71d772e.svg";
export { ForwardRef as ReactComponent };